import { render, staticRenderFns } from "./ContentSubscriptions.vue?vue&type=template&id=8e2851aa&"
import script from "./ContentSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./ContentSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports